import { registerPlugin } from '@capacitor/core';

import type { BrazePluginV2Plugin } from './definitions';

const BrazePluginV2 = registerPlugin<BrazePluginV2Plugin>('BrazePluginV2', {
  web: () => import('./web').then((m) => new m.BrazePluginV2Web()),
});

export * from './definitions';
export { BrazePluginV2 };
